<template>
  <el-dialog :close-on-click-modal="false" v-dialogDrag :title="title" :visible.sync="detailDialog" width="80%" append-to-body :before-close="handleClose">
    <div class="max-height-60">
      <el-form :model="form" :inline="true" label-width="100px">
        <el-form-item prop="vipName" label="门店名称:" v-if="title=='明细'">
          <div class="form-width-ms">{{form.storeName}}</div>
        </el-form-item>
        <el-form-item label="手机号码:" prop="mobilePhone">
          <label slot="label">手&nbsp;&nbsp;机&nbsp;&nbsp;号</label>
          <div class="form-width-ms">
            <div v-show="title=='明细'">
              {{form.mobilePhone}}
            </div>
          </div>
        </el-form-item>
        <el-form-item label="姓名:" prop="name">
          <div class="form-width-ms">
            <span>{{form.memberName}}</span>
          </div>
        </el-form-item>
        <el-form-item label="消费单号:" prop="name">
          <div class="form-width-ms">
            <div v-show="title=='明细'">
              {{form.sourceDocNum}}
            </div>

          </div>
        </el-form-item>
        <el-form-item label="消费时间:" prop="name">
          <div class="form-width-ms">
            {{form.cashDate}}
          </div>
        </el-form-item>
        <el-form-item label="退款时间:" prop="name">
          <div class="form-width-ms">
            {{form.refundDate}}
          </div>
        </el-form-item>
        <el-form-item label="审核时间:" prop="name">
          <div class="form-width-ms">
            {{form.auditDate | initDate}}
          </div>
        </el-form-item>
        <el-form-item label="成交金额:" prop="sex">
          <div class="form-width-ms">
            <span>{{summoney?summoney:''}}</span>
          </div>
        </el-form-item>
        <el-form-item label="退款金额:" prop="sex">
          <div class="form-width-ms">
            <span>{{refundMoney}}</span>
          </div>
        </el-form-item><br>

        <el-form-item label="补偿金额:" prop="compensation">
          <div class="form-width-ms">
            {{compensation}}
          </div>
        </el-form-item>
        <el-form-item label="收款银行:">
          <div class="form-width-ms">
            <div v-show="title=='明细'">
              {{refundType}}
            </div>

          </div>
        </el-form-item>
        <el-form-item label="收款账户:">
          <div class="form-width-ms">
            <div v-show="title=='明细'">
              {{refundAccount}}
            </div>

          </div>
        </el-form-item>
        <el-form-item label="收款人:">
          <div class="form-width-ms">
            <div v-show="title=='明细'">
              {{payee}}
            </div>

          </div>
        </el-form-item>
        <el-table style="margin-left:30px" :data="refCashLists" v-if="refCashListsShow" @row-click="handleRowClick" ref="multipleTable" highlight-current-row row-key="index">
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="flex justify-start align-center  flex-wrap ">
                <el-form inline class="margin-top-xs margin-left-xs">
                  <el-form-item label='美发师'>
                    <div class="flex align-center form-width-m">
                      <el-select filterable default-first-option clearable @clear="clear(scope.row,'zhonggongList')" v-model="scope.row.zhonggongLists" placeholder="请选择" @change="handleChange($event,scope.row,'zhonggongList')">
                        <el-option v-for="(item,index) in options" :key="index" :label="item.label" :value="item.id">
                        </el-option>
                      </el-select>
                      <!-- <div class="el-icon-circle-close text-xs text-cyan" @click.stop="scope.row.zhonggongLists=null,scope.row.zhonggongList.splice(0,1)"></div> -->
                      <div class="el-icon-edit-outline text-xs text-cyan" @click.stop="openStaffRatio(scope.row,scope.$index,'zhonggongList')"></div>
                    </div>
                  </el-form-item>
                  <el-form-item label='美容师'>
                    <div class="flex align-center form-width-m">
                      <el-select filterable default-first-option clearable @clear="clear(scope.row,'largeList')" v-model="scope.row.largeLists" placeholder="请选择" @change="handleChange($event,scope.row,'largeList')">
                        <el-option v-for="(item,index) in options" :key="index" :label="item.label" :value="item.id">
                        </el-option>
                      </el-select>
                      <!-- <div class="el-icon-circle-close text-xs text-cyan" @click.stop="scope.row.largeLists=null,scope.row.largeList.splice(0,1)"></div> -->
                      <div class="el-icon-edit-outline text-xs text-cyan" @click.stop="openStaffRatio(scope.row,scope.$index,'largeList')"></div>
                    </div>
                  </el-form-item>
                  <el-form-item label='技师'>
                    <div class="flex align-center form-width-m">
                      <el-select filterable default-first-option clearable @clear="clear(scope.row,'technicianLists')" v-model="scope.row.technicianLists" placeholder="请选择" @change="handleChange($event,scope.row,'technicianList')">
                        <el-option v-for="(item,index) in options" :key="index" :label="item.label" :value="item.id">
                        </el-option>
                      </el-select>
                      <!-- <div class="el-icon-circle-close text-xs text-cyan" @click.stop="scope.row.technicianLists=null,scope.row.technicianList.splice(0,1)"></div> -->
                      <div class="el-icon-edit-outline text-xs text-cyan" @click.stop="openStaffRatio(scope.row,scope.$index,'technicianList')"></div>
                    </div>
                  </el-form-item>
                  <el-form-item label='助理'>
                    <div class="flex align-center form-width-m">
                      <el-select filterable default-first-option clearable @clear="clear(scope.row,'smallLists')" v-model="scope.row.smallLists" placeholder="请选择" @change="handleChange($event,scope.row,'smallList')">
                        <el-option v-for="(item,index) in options" :key="index" :label="item.label" :value="item.id">
                        </el-option>
                      </el-select>
                      <!-- <div class="el-icon-circle-close text-xs text-cyan" @click.stop="scope.row.smallLists=null,scope.row.smallList.splice(0,1)"></div> -->
                      <div class="el-icon-edit-outline text-xs text-cyan" @click.stop="openStaffRatio(scope.row,scope.$index,'smallList')"></div>
                    </div>
                  </el-form-item>
                  <el-form-item label='高管'>
                    <div class="flex align-center form-width-m">
                      <el-select filterable default-first-option clearable @clear="clear(scope.row,'managerLists')" v-model="scope.row.managerLists" placeholder="请选择" @change="handleChange($event,scope.row,'managerList')">
                        <el-option v-for="(item,index) in managerOptions" :key="index" :label="item.label" :value="item.id">
                        </el-option>
                      </el-select>
                      <!-- <div class="el-icon-circle-close text-xs text-cyan" @click.stop="scope.row.managerLists=null,scope.row.managerList.splice(0,1)"></div> -->
                      <div class="el-icon-edit-outline text-xs text-cyan" @click.stop="openStaffRatio(scope.row,scope.$index,'managerList')"></div>
                    </div>
                  </el-form-item>
                  <el-form-item label='管理层'>
                    <div class="flex align-center form-width-m">
                      <el-select filterable default-first-option clearable @clear="clear(scope.row,'adminLists')" v-model="scope.row.adminLists" placeholder="请选择" @change="handleChange($event,scope.row,'adminList')">
                        <el-option v-for="(item,index) in adminOptions" :key="index" :label="item.label" :value="item.id">
                        </el-option>
                      </el-select>
                      <!-- <div class="el-icon-circle-close text-xs text-cyan" @click.stop="scope.row.adminLists=null,scope.row.adminList.splice(0,1)"></div> -->
                      <div class="el-icon-edit-outline text-xs text-cyan" @click.stop="openStaffRatio(scope.row,scope.$index,'adminList')"></div>
                    </div>
                  </el-form-item>
                  <br>
                </el-form>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column type="selection" width="55" align="center" v-if="title=='修改'"></el-table-column>
          <el-table-column align="center" min-width="150" prop="sourceDocNum" label="消费单号"></el-table-column>
          <el-table-column align="center" min-width="175" v-if="title=='修改'" prop="cashDate" label="消费时间"></el-table-column>
          <el-table-column align="center" min-width="150" prop="projectName" label="消费项目">
          </el-table-column>
          <el-table-column align="center" min-width="80" prop="transactionPrice" label="成交金额"></el-table-column>
          <el-table-column align="center" min-width="80" prop="cashRefundMoney" label="退款金额">
            <template slot-scope="scope">
              <div v-show="title=='明细'">
                {{scope.row.cashRefundMoney}}
              </div>

            </template>
          </el-table-column>
          <el-table-column align="center" min-width="80" prop="cashCompensation" label="补偿金额">
            <template slot-scope="scope">
              <div v-show="title=='明细'">
                {{scope.row.cashCompensation}}
              </div>

            </template>
          </el-table-column>
          <!-- <el-table-column align="center"  prop="cardAmount" label="充值卡付">
            <template slot-scope="scope">
              {{ scope.row.cardAmount?scope.row.cardAmount.toFixed(2)*1:0 }}
            </template>
          </el-table-column>
          <el-table-column align="center"  prop="cashAmount" label="现金付">
            <template slot-scope="scope">
              {{ scope.row.cashAmount?scope.row.cashAmount.toFixed(2)*1:0 }}
            </template>
          </el-table-column>
          <el-table-column align="center"  prop="sourceDocNum" label="实付金额">
            <template slot-scope="scope">
              {{ scope.row.cardAmount?scope.row.cardAmount.toFixed(2)*1:0 + scope.row.cardAmount?scope.row.cardAmount.toFixed(2)*1:0 }}
            </template>
          </el-table-column> -->
          <el-table-column align="center" min-width="120" label="付款方式">
            <template slot-scope="scope">
              <div v-show="scope.row.courseAccountId==null">卡包支付</div>
              <div v-show="scope.row.courseAccountId!=null">现付/卡付</div>
            </template>
          </el-table-column>
        </el-table>
        <el-form-item label="退款备注:" prop="refundReason">
          <div style="width:720px">
            <div v-show="title=='明细'">
              {{form.refundReason}}
            </div>

          </div>
        </el-form-item><br>
        <el-form-item label="附带文件">
          <div v-show="title=='明细'" v-for="(item,index) in  fileList" :key="index">
            <div style="width:100px;cursor: pointer; margin:0 5px;">
              <el-image @click="(url = item.url,openImageDialog=true,urlForm = item)" :src='item.url'>
                <div slot="error" class="image-slot">
                  <div title="点击下载文件" style="cursor: pointer;width:300px;" @click="directDown(item)">{{item.fileName}}</div>
                </div>
              </el-image>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <staffratio ref="staffratio" @staffratioData="staffratioData"></staffratio>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" type="primary" plain @click="cancel()">关闭</el-button>
    </span>
    <el-dialog :close-on-click-modal="false" v-dialogDrag title="图片预览" :visible.sync="openImageDialog" append-to-body>
      <el-image style="height: 60vh;width:100%" :src="url" fit="contain"></el-image>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" plain @click="openImageDialog = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="confirmImage(openImageDialog=false)">下 载</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { refCashList, refOrderDownload } from "@/api/eashier.js";
import { partten } from "../../../../../partten/index.js";
import admin from "@/components/staffList/admin/index";
import manager from "@/components/staffList/manager/index";
import staffsles from "@/components/staffList/staff/index";
import staffratio from "./staffratio";
export default {
  components: {
    staffsles,
    manager,
    admin,
    staffratio,
  },
  data() {
    return {
      detailDialog: false,
      refCashListsShow: false,
      activeNames: "员工",
      rowfromWidth: "80px",
      sessionStorageData: {}, //门店参数集合
      refundType: null,
      refundAccount: null,
      payee: null,
      refundReason: null,
      refundMoney: null,
      compensation: null,
      fileData: [],
      fileList: [],
      title: "", //弹窗标题
      form: {}, //主对象
      summoney: null,
      editIndex: -1,
      managerOptions: [],
      options: [],
      adminOptions: [],
      openImageDialog: false,
      url: "",
      urlForm: {},
    };
  },
  filters:{
    initDate:function(time){
      if(time){
        let date = new Date(time);
        let Y = date.getFullYear() + '-';
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';
        let h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':';
        let m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ':';
        let s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
        let strDate = Y + M + D + h + m + s;
        return strDate
      }else return '--'
    }
  },
  methods: {
    directDown(item) {
      let url = {
        fileName: item.fileName,
        filePath: item.filePath,
      };
      refOrderDownload(url).then((res) => {
        //console.log(res);
        let blob = new Blob([res]);
        var a = document.createElement("a");
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = item.fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      });
    },
    confirmImage() {
      let url = {
        fileName: this.urlForm.fileName,
        filePath: this.urlForm.filePath,
      };
      refOrderDownload(url).then((res) => {
        //console.log(res);
        let blob = new Blob([res]);
        var a = document.createElement("a");
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = this.urlForm.fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      });
    },
    //关闭弹窗前的回调方法
    handleClose() {
      this.form = Object.assign({});
      this.fileList = [];
      this.detailDialog = false;
      this.fileData = [];
    },
    clear(row, text) {
      console.log(text);
      let form = { ...row };
      form[text] = [];
      console.log(form);
      this.refCashLists.splice(row.index, 1, form);
    },
    handleChange(data, row, text) {
      let form = { ...row };
      console.log(data);

      if (text == "managerList") {
        console.log(this.managerOptions);
        this.managerOptions.forEach((item, index) => {
          if (item.id == data) {
            item.ratio = 100;
            form[text] = [];
            form[text].push(item);
            form.texts = item.label;
          }
        });
      } else if (text == "adminList") {
        this.adminOptions.forEach((item, index) => {
          if (item.id == data) {
            item.ratio = 100;
            form[text] = [];
            form[text].push(item);
            form.texts = item.label;
          }
        });
      } else {
        this.options.forEach((item, index) => {
          if (item.id == data) {
            item.ratio = 100;
            form[text] = [];
            form[text].push(item);
            form.texts = item.label;
          }
        });
      }
      console.log(form);
      this.refCashLists.splice(row.index, 1, form);
      // this.$refs.list.toggleRowExpansion(row);
    },
    staffratioData(v) {
      let form = this.refCashLists[this.editIndex];
      let texts = v.text + "s";
      form[v.text] = v.list;
      form[texts] = v.list[0].label;
      this.refCashLists.splice(this.editIndex, 1, form);
    },
    openStaffRatio(row, index, text) {
      this.editIndex = index;
      this.$refs.staffratio.show(row, text);
    },
    //自定义文件上传拦截方法
    uploadFile(file) {
      this.fileData.append("fileList", file.file);
    },
    setStaff() {
      var that = this;
      this.$nextTick(() => {
        console.log(that.$refs.staffsles);
        that.$refs.staffsles.show(that.form.staffLists);
        that.$refs.admin.show(that.form.adminList);
        that.$refs.manager.show(that.form.managerList);
      });
    },
    //员工占比返回方法
    staffslesData(v) {
      this.form.staffLists = [...v];
    },
    //高管占比返回方法
    managerData(v) {
      this.form.managerList = [...v];
    },
    //管理员占比返回方法
    adminData(v) {
      this.form.adminList = [...v];
    },
    cancel() {
      this.detailDialog = false;
      this.$emit("detailData");
    },
    //点击行触发，选中或不选中复选框
    handleRowClick(row, column, event) {
      if (this.title != "明细") {
        this.$nextTick(() => {
          this.$refs.multipleTable.toggleRowExpansion(row);
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      }
    },
    //组件传值
    show(form, title) {
      this.form = {};
      this.title = title;
      this.detailDialog = true;
      this.sessionStorageData = JSON.parse(
        sessionStorage.getItem("sessionStorageData")
      );
      this.getData(form);
    },
    getData(form) {
      this.title = "明细";
      refCashList({
        refundNum: form.refundNum,
        refundOrderId: form.id,
        storeId: form.storeId,
      }).then((res) => {
        //console.log(res);
        if (res.code == "000000") {
          if (res.rows.length == 0) {
            this.$alert("未找到相关明细", "提示", {
              confirmButtonText: "确定",
              confirmButtonClass: "confirmbtnFalses",
              type: "warning",
              center: true,
              callback: (action) => {},
            });
          } else {
            this.form = {...form};
            this.refCashListsShow = true;
            this.refCashLists = res.rows;
            this.refCashLists.forEach((item) => {
              if(item.type == 1){
                this.$nextTick(()=>{
                  this.$refs.multipleTable.toggleRowSelection(item)
                })
              }
              if (item.largeList.length != 0) {
                item.largeLists =
                  item.largeList[0].brandNumber +
                  "-" +
                  item.largeList[0].staffName;
              } else {
                item.largeLists = "";
              }
              if (item.zhonggongList.length != 0) {
                item.zhonggongLists =
                  item.zhonggongList[0].brandNumber +
                  "-" +
                  item.zhonggongList[0].staffName;
              } else {
                item.zhonggongLists = "";
              }
              if (item.smallList.length != 0) {
                item.smallLists =
                  item.smallList[0].brandNumber +
                  "-" +
                  item.smallList[0].staffName;
              } else {
                item.smallLists = "";
              }
              if (item.technicianList.length != 0) {
                item.technicianLists =
                  item.technicianList[0].brandNumber +
                  "-" +
                  item.technicianList[0].staffName;
              } else {
                item.technicianLists = "";
              }
            });
            this.refundType = form.refundType;
            this.payee = form.payee;
            this.refundAccount = form.refundAccount;
            this.refundType = form.refundType;
            this.refundReason = form.refundReason;
            this.compensation = form.compensation;
            this.refundMoney = form.refundMoney;
            this.form.cashDate = res.rows[0].cashDate;
            this.form = Object.assign(this.form, res.rows[0]);
            let num = 0;
            res.rows.forEach((item) => {
              item.sourceDocNum = form.sourceDocNum;
              num += item.transactionPrice * 1;
            });
            this.summoney = num;
            res.rows[0].fileLists.forEach((item) => {
              item.imageShow = false;
              item.url = partten.https + item.filePath + "/" + item.fileName;
            });
            this.fileList = res.rows[0].fileLists;
          }
        } else {
          this.$alert(res.message, "提示", {
            confirmButtonText: "确定",
            confirmButtonClass: "confirmbtnFalses",
            type: "warning",
            center: true,
            callback: (action) => {},
          });
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/eashier/refund/components/detail.vue